function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Chat_logo",
  "data-name": "Chat logo",
  transform: "translate(0.05 0.05)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1083",
  "data-name": "Path 1083",
  d: "M2981.089,3345.349h-7.812a1.387,1.387,0,0,0-1.387,1.387v6.282a1.387,1.387,0,0,0,1.387,1.387h7.812Z",
  transform: "translate(-2971.891 -3321.101)",
  fill: "#1fa065",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1084",
  "data-name": "Path 1084",
  d: "M3250.663,2803.987h-6.282a1.387,1.387,0,0,0-1.387,1.387v7.806h9.055v-7.806A1.387,1.387,0,0,0,3250.663,2803.987Z",
  transform: "translate(-3230.851 -2803.987)",
  fill: "#e01e5a",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1085",
  "data-name": "Path 1085",
  d: "M3784.938,3075.09h-7.915v9.055h7.915a1.387,1.387,0,0,0,1.387-1.387v-6.281A1.387,1.387,0,0,0,3784.938,3075.09Z",
  transform: "translate(-3740.96 -3062.947)",
  fill: "#ecb22e",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1086",
  "data-name": "Path 1086",
  d: "M3511.435,3612.89v7.828a1.386,1.386,0,0,0,1.387,1.387h6.282a1.386,1.386,0,0,0,1.387-1.387v-7.828Z",
  transform: "translate(-3487.268 -3576.658)",
  fill: "#26b3d3",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1087",
  "data-name": "Path 1087",
  d: "M2982.85,3083.533c0-4.5,4.518-8.2,10.239-8.552v-.034h-9.055v.007h-10.756a1.387,1.387,0,0,0-1.387,1.387v6.281a1.387,1.387,0,0,0,1.387,1.387h9.589C2982.856,3083.851,2982.85,3083.693,2982.85,3083.533Z",
  transform: "translate(-2971.891 -3062.81)",
  fill: "#e01e5a",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1088",
  "data-name": "Path 1088",
  d: "M3242.972,3352.5v8.735h0V3372a1.387,1.387,0,0,0,1.386,1.387h6.282a1.387,1.387,0,0,0,1.386-1.387V3357.21C3248.064,3356.967,3244.678,3355.115,3242.972,3352.5Z",
  transform: "translate(-3230.83 -3327.936)",
  fill: "#1fa065",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1089",
  "data-name": "Path 1089",
  d: "M3531.247,3345.349h-11.752a9.1,9.1,0,0,1-2.568,2.751l-.208.149v4.39l-3.121-2.885-.271.08a13.834,13.834,0,0,1-1.891.416v4.139h20.018a1.387,1.387,0,0,0,1.18-1.372v-6.282A1.387,1.387,0,0,0,3531.247,3345.349Z",
  transform: "translate(-3487.268 -3321.101)",
  fill: "#26b3d3",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1090",
  "data-name": "Path 1090",
  d: "M3520.387,2823.542v-18.692a1.387,1.387,0,0,0-1.284-.862h-6.282a1.387,1.387,0,0,0-1.387,1.387v10.906C3516.1,2816.961,3519.739,2819.889,3520.387,2823.542Z",
  transform: "translate(-3487.268 -2803.987)",
  fill: "#ecb22e",
  stroke: "#fff",
  strokeWidth: 0.1,
  fillRule: "evenodd"
}));

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.465,
    height: 45.547,
    viewBox: "0 0 45.465 45.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.035bbc26.svg";
export { ForwardRef as ReactComponent };